<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login form</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    prepend-icon="person"
                    v-model="user.email"
                    :rules="emailRules"
                    name="login"
                    label="Login"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    v-model="user.password"
                    :rules="passwordRules"
                    name="password"
                    label="Password"
                    type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="submit" color="primary">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      valid: true,
      emailRules: [
        (email) => {
          if (email.trim() === '') return 'Email-ul trebuie completat.';
          return true;
        },
      ],
      passwordRules: [
        (password) => {
          if (password.trim() === '') return 'Parola trebuie completata.';
          return true;
        },
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.$store
          .dispatch('auth/login', this.user)
          .then(() => {
            this.$router.push({ path: '/' });
          });
      }
    },
  },
};
</script>

<style>
</style>
